module.exports = __webpack_public_path__ + "media/brands/fruehauf-4d3119c6.png";